import * as localForage from "localforage";
import { applyMiddleware, compose, createStore } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import createSagaMiddleware from "redux-saga";
// import { PersistPartial } from 'redux-persist/es/persistReducer';
import { createRootReducer } from "./reducer";
import rootSaga from "./sagas";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import history from "../services/browser";
import { refreshTokenMiddleware } from "./RefreshTokenMiddleware";

// import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "driverportal",
  storage: localForage,
  stateReconciler: autoMergeLevel2,
};
const sagaMiddleware = createSagaMiddleware();

export default function configureStore(initialState) {
  const reducer = createRootReducer(history);
  const rootReducer = (state, action) => {
    return reducer(state, action);
  };
  const reduxMiddleware = [refreshTokenMiddleware, sagaMiddleware];
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const persistedReducer = persistReducer(persistConfig, rootReducer);
  const store = createStore(
    persistedReducer,
    initialState,
    composeEnhancers(applyMiddleware(...reduxMiddleware))
  );

  const persistor = persistStore(store);
  sagaMiddleware.run(rootSaga);

  return { persistor, store };
}

// const sagaMiddleware = createSagaMiddleware();

// const reduxMiddleware = [
//            refreshTokenMiddleware,
//            sagaMiddleware,
//          ];

// const reducer = createRootReducer(history);
//    const rootReducer = (state, action) => {
//         return reducer(state, action);
//       };

// const persistedReducer = persistReducer(persistConfig, rootReducer);

// let store = createStore(persistedReducer, applyMiddleware(...reduxMiddleware));
// let persistor = persistStore(store);

// export { store, persistor, sagaMiddleware };
